import React, { useRef } from 'react'
import { useDispatch } from 'react-redux'
import clsx from 'clsx'

import { makeStyles } from '@mui/styles'
import AccountButton from './account-button'

import useWebSocketEvent, { EventTypes } from '@/modules/webSocket'
import { fetchData as fetchTenantData } from '@/redux/ducks/tenant/info'
import { fetchData as fetchTenantSetting } from '@/redux/ducks/tenant/settings'
import { updateSubscriptionDetails } from '@/redux/ducks/subscription/details'
import NotificationButton from '@/modules/base/components/notification/button/notification-button'
import SearchButton from '@/modules/base/components/search/button/search-button'

const useStyles = makeStyles(theme => ({
  menuHeaderWrapper: {
    marginTop: 10,
    overflowX: 'hidden',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
  button: {
    width: '100%',
    marginTop: 30,
  },
  [theme.devices.mobile]: {
    container: {
      flexDirection: 'row',
      margin: 0,
      width: 'auto',
    },
    iconWrapper: {
      marginRight: 30,
    },
    button: {
      marginTop: 0,
    },
  },
}))

const MenuHeader = (props) => {
  const { className, toggleMenuOverlay, menuOverlayOpen, closeMenuOverlay } = props
  const dispatch = useDispatch()
  const classes = useStyles()

  useWebSocketEvent(EventTypes.TENANT_INFO_REFRESH, (ms) => {
    updateSubscriptionDetails(true, true)
    dispatch(fetchTenantData())
    dispatch(fetchTenantSetting())
  })

  const buttonStyles = useRef({
    root: classes.button,
  })

  return (
    <div className={clsx(classes.container, classes.menuHeaderWrapper, className)}>
      <AccountButton
        toggleMenuOverlay={toggleMenuOverlay}
        menuOverlayOpen={menuOverlayOpen}
        closeMenuOverlay={closeMenuOverlay} activeClass={classes.active}
      />
      <SearchButton styles={buttonStyles.current} />
      <NotificationButton styles={buttonStyles.current} />
    </div>
  )
}

export default MenuHeader
